"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _acate = _interopRequireDefault(require("./35_group_2024_11_08/acate"));

var _ameno = _interopRequireDefault(require("./35_group_2024_11_08/ameno"));

var _aosta = _interopRequireDefault(require("./35_group_2024_11_08/aosta"));

var _arenaPo = _interopRequireDefault(require("./35_group_2024_11_08/arena-po"));

var _arquataScrivia = _interopRequireDefault(require("./35_group_2024_11_08/arquata-scrivia"));

var _baldisseroTorinese = _interopRequireDefault(require("./35_group_2024_11_08/baldissero-torinese"));

var _baragiano = _interopRequireDefault(require("./35_group_2024_11_08/baragiano"));

var _barberinoTavarnelle = _interopRequireDefault(require("./35_group_2024_11_08/barberino-tavarnelle"));

var _bariSardo = _interopRequireDefault(require("./35_group_2024_11_08/bari-sardo"));

var _belvedereMarittimo = _interopRequireDefault(require("./35_group_2024_11_08/belvedere-marittimo"));

var _bernateTicino = _interopRequireDefault(require("./35_group_2024_11_08/bernate-ticino"));

var _bonateSopra = _interopRequireDefault(require("./35_group_2024_11_08/bonate-sopra"));

var _borgosesia = _interopRequireDefault(require("./35_group_2024_11_08/borgosesia"));

var _bornasco = _interopRequireDefault(require("./35_group_2024_11_08/bornasco"));

var _boscoChiesanuova = _interopRequireDefault(require("./35_group_2024_11_08/bosco-chiesanuova"));

var _bosnasco = _interopRequireDefault(require("./35_group_2024_11_08/bosnasco"));

var _buggiano = _interopRequireDefault(require("./35_group_2024_11_08/buggiano"));

var _cabras = _interopRequireDefault(require("./35_group_2024_11_08/cabras"));

var _calasetta = _interopRequireDefault(require("./35_group_2024_11_08/calasetta"));

var _campolongoTapogliano = _interopRequireDefault(require("./35_group_2024_11_08/campolongo-tapogliano"));

var _campomarino = _interopRequireDefault(require("./35_group_2024_11_08/campomarino"));

var _campomorone = _interopRequireDefault(require("./35_group_2024_11_08/campomorone"));

var _camporosso = _interopRequireDefault(require("./35_group_2024_11_08/camporosso"));

var _camporotondoEtneo = _interopRequireDefault(require("./35_group_2024_11_08/camporotondo-etneo"));

var _caneva = _interopRequireDefault(require("./35_group_2024_11_08/caneva"));

var _cannobio = _interopRequireDefault(require("./35_group_2024_11_08/cannobio"));

var _capoterra = _interopRequireDefault(require("./35_group_2024_11_08/capoterra"));

var _carlentini = _interopRequireDefault(require("./35_group_2024_11_08/carlentini"));

var _caronia = _interopRequireDefault(require("./35_group_2024_11_08/caronia"));

var _casalzuigno = _interopRequireDefault(require("./35_group_2024_11_08/casalzuigno"));

var _cascina = _interopRequireDefault(require("./35_group_2024_11_08/cascina"));

var _cassinaDePecchi = _interopRequireDefault(require("./35_group_2024_11_08/cassina-de-pecchi"));

var _castellArquato = _interopRequireDefault(require("./35_group_2024_11_08/castell-arquato"));

var _castelloDArgile = _interopRequireDefault(require("./35_group_2024_11_08/castello-d-argile"));

var _cattolicaEraclea = _interopRequireDefault(require("./35_group_2024_11_08/cattolica-eraclea"));

var _cervo = _interopRequireDefault(require("./35_group_2024_11_08/cervo"));

var _cesanaTorinese = _interopRequireDefault(require("./35_group_2024_11_08/cesana-torinese"));

var _chiesaInValmalenco = _interopRequireDefault(require("./35_group_2024_11_08/chiesa-in-valmalenco"));

var _conegliano = _interopRequireDefault(require("./35_group_2024_11_08/conegliano"));

var _costaVolpino = _interopRequireDefault(require("./35_group_2024_11_08/costa-volpino"));

var _costarainera = _interopRequireDefault(require("./35_group_2024_11_08/costarainera"));

var _crodo = _interopRequireDefault(require("./35_group_2024_11_08/crodo"));

var _cuneo = _interopRequireDefault(require("./35_group_2024_11_08/cuneo"));

var _fabbricaCurone = _interopRequireDefault(require("./35_group_2024_11_08/fabbrica-curone"));

var _falcone = _interopRequireDefault(require("./35_group_2024_11_08/falcone"));

var _falerna = _interopRequireDefault(require("./35_group_2024_11_08/falerna"));

var _faraGeraDAdda = _interopRequireDefault(require("./35_group_2024_11_08/fara-gera-d-adda"));

var _fluminimaggiore = _interopRequireDefault(require("./35_group_2024_11_08/fluminimaggiore"));

var _forzaDAgro = _interopRequireDefault(require("./35_group_2024_11_08/forza-d-agro"));

var _francolise = _interopRequireDefault(require("./35_group_2024_11_08/francolise"));

var _furnari = _interopRequireDefault(require("./35_group_2024_11_08/furnari"));

var _fusignano = _interopRequireDefault(require("./35_group_2024_11_08/fusignano"));

var _giaveraDelMontello = _interopRequireDefault(require("./35_group_2024_11_08/giavera-del-montello"));

var _gioiosaMarea = _interopRequireDefault(require("./35_group_2024_11_08/gioiosa-marea"));

var _govone = _interopRequireDefault(require("./35_group_2024_11_08/govone"));

var _gravellonaLomellina = _interopRequireDefault(require("./35_group_2024_11_08/gravellona-lomellina"));

var _guspini = _interopRequireDefault(require("./35_group_2024_11_08/guspini"));

var _iglesias = _interopRequireDefault(require("./35_group_2024_11_08/iglesias"));

var _incisaScapaccino = _interopRequireDefault(require("./35_group_2024_11_08/incisa-scapaccino"));

var _laMaddalena = _interopRequireDefault(require("./35_group_2024_11_08/la-maddalena"));

var _lecce = _interopRequireDefault(require("./35_group_2024_11_08/lecce"));

var _luino = _interopRequireDefault(require("./35_group_2024_11_08/luino"));

var _magomadas = _interopRequireDefault(require("./35_group_2024_11_08/magomadas"));

var _malesco = _interopRequireDefault(require("./35_group_2024_11_08/malesco"));

var _manduria = _interopRequireDefault(require("./35_group_2024_11_08/manduria"));

var _maracalagonis = _interopRequireDefault(require("./35_group_2024_11_08/maracalagonis"));

var _margno = _interopRequireDefault(require("./35_group_2024_11_08/margno"));

var _marmirolo = _interopRequireDefault(require("./35_group_2024_11_08/marmirolo"));

var _marrubiu = _interopRequireDefault(require("./35_group_2024_11_08/marrubiu"));

var _maser = _interopRequireDefault(require("./35_group_2024_11_08/maser"));

var _meina = _interopRequireDefault(require("./35_group_2024_11_08/meina"));

var _menfi = _interopRequireDefault(require("./35_group_2024_11_08/menfi"));

var _mesola = _interopRequireDefault(require("./35_group_2024_11_08/mesola"));

var _mezzana = _interopRequireDefault(require("./35_group_2024_11_08/mezzana"));

var _mioglia = _interopRequireDefault(require("./35_group_2024_11_08/mioglia"));

var _misiliscemi = _interopRequireDefault(require("./35_group_2024_11_08/misiliscemi"));

var _monforteSanGiorgio = _interopRequireDefault(require("./35_group_2024_11_08/monforte-san-giorgio"));

var _montecosaro = _interopRequireDefault(require("./35_group_2024_11_08/montecosaro"));

var _mottaSantAnastasia = _interopRequireDefault(require("./35_group_2024_11_08/motta-sant-anastasia"));

var _muggia = _interopRequireDefault(require("./35_group_2024_11_08/muggia"));

var _naso = _interopRequireDefault(require("./35_group_2024_11_08/naso"));

var _ne = _interopRequireDefault(require("./35_group_2024_11_08/ne"));

var _orosei = _interopRequireDefault(require("./35_group_2024_11_08/orosei"));

var _palazzago = _interopRequireDefault(require("./35_group_2024_11_08/palazzago"));

var _palermo = _interopRequireDefault(require("./35_group_2024_11_08/palermo"));

var _palmaDiMontechiaro = _interopRequireDefault(require("./35_group_2024_11_08/palma-di-montechiaro"));

var _perugia = _interopRequireDefault(require("./35_group_2024_11_08/perugia"));

var _petrosino = _interopRequireDefault(require("./35_group_2024_11_08/petrosino"));

var _ponteNizza = _interopRequireDefault(require("./35_group_2024_11_08/ponte-nizza"));

var _pontechianale = _interopRequireDefault(require("./35_group_2024_11_08/pontechianale"));

var _portoCesareo = _interopRequireDefault(require("./35_group_2024_11_08/porto-cesareo"));

var _portoscuso = _interopRequireDefault(require("./35_group_2024_11_08/portoscuso"));

var _posada = _interopRequireDefault(require("./35_group_2024_11_08/posada"));

var _pulsano = _interopRequireDefault(require("./35_group_2024_11_08/pulsano"));

var _realmonte = _interopRequireDefault(require("./35_group_2024_11_08/realmonte"));

var _rezzoaglio = _interopRequireDefault(require("./35_group_2024_11_08/rezzoaglio"));

var _roveredoInPiano = _interopRequireDefault(require("./35_group_2024_11_08/roveredo-in-piano"));

var _rovetta = _interopRequireDefault(require("./35_group_2024_11_08/rovetta"));

var _salaBaganza = _interopRequireDefault(require("./35_group_2024_11_08/sala-baganza"));

var _sanCesarioDiLecce = _interopRequireDefault(require("./35_group_2024_11_08/san-cesario-di-lecce"));

var _sanGiovanniSuergiu = _interopRequireDefault(require("./35_group_2024_11_08/san-giovanni-suergiu"));

var _sanGodenzo = _interopRequireDefault(require("./35_group_2024_11_08/san-godenzo"));

var _sanPietroDiFeletto = _interopRequireDefault(require("./35_group_2024_11_08/san-pietro-di-feletto"));

var _sanPietroInCariano = _interopRequireDefault(require("./35_group_2024_11_08/san-pietro-in-cariano"));

var _sanVeroMilis = _interopRequireDefault(require("./35_group_2024_11_08/san-vero-milis"));

var _sanZenoneAlLambro = _interopRequireDefault(require("./35_group_2024_11_08/san-zenone-al-lambro"));

var _santAlessioSiculo = _interopRequireDefault(require("./35_group_2024_11_08/sant-alessio-siculo"));

var _santAnnaArresi = _interopRequireDefault(require("./35_group_2024_11_08/sant-anna-arresi"));

var _santAntonioDiGallura = _interopRequireDefault(require("./35_group_2024_11_08/sant-antonio-di-gallura"));

var _santaTeresaDiRiva = _interopRequireDefault(require("./35_group_2024_11_08/santa-teresa-di-riva"));

var _santarcangeloDiRomagna = _interopRequireDefault(require("./35_group_2024_11_08/santarcangelo-di-romagna"));

var _semproniano = _interopRequireDefault(require("./35_group_2024_11_08/semproniano"));

var _sestoCalende = _interopRequireDefault(require("./35_group_2024_11_08/sesto-calende"));

var _siculiana = _interopRequireDefault(require("./35_group_2024_11_08/siculiana"));

var _sorso = _interopRequireDefault(require("./35_group_2024_11_08/sorso"));

var _spadafora = _interopRequireDefault(require("./35_group_2024_11_08/spadafora"));

var _spinetoli = _interopRequireDefault(require("./35_group_2024_11_08/spinetoli"));

var _stintino = _interopRequireDefault(require("./35_group_2024_11_08/stintino"));

var _strongoli = _interopRequireDefault(require("./35_group_2024_11_08/strongoli"));

var _terralba = _interopRequireDefault(require("./35_group_2024_11_08/terralba"));

var _tresnuraghes = _interopRequireDefault(require("./35_group_2024_11_08/tresnuraghes"));

var _vadoLigure = _interopRequireDefault(require("./35_group_2024_11_08/vado-ligure"));

var _valMasino = _interopRequireDefault(require("./35_group_2024_11_08/val-masino"));

var _valeggioSulMincio = _interopRequireDefault(require("./35_group_2024_11_08/valeggio-sul-mincio"));

var _valledoria = _interopRequireDefault(require("./35_group_2024_11_08/valledoria"));

var _vallefoglia = _interopRequireDefault(require("./35_group_2024_11_08/vallefoglia"));

var _valmadrera = _interopRequireDefault(require("./35_group_2024_11_08/valmadrera"));

var _valtournenche = _interopRequireDefault(require("./35_group_2024_11_08/valtournenche"));

var _vignate = _interopRequireDefault(require("./35_group_2024_11_08/vignate"));

var _villaputzu = _interopRequireDefault(require("./35_group_2024_11_08/villaputzu"));

var _villasimius = _interopRequireDefault(require("./35_group_2024_11_08/villasimius"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _acate["default"], {}, _ameno["default"], {}, _aosta["default"], {}, _arenaPo["default"], {}, _arquataScrivia["default"], {}, _baldisseroTorinese["default"], {}, _baragiano["default"], {}, _barberinoTavarnelle["default"], {}, _bariSardo["default"], {}, _belvedereMarittimo["default"], {}, _bernateTicino["default"], {}, _bonateSopra["default"], {}, _borgosesia["default"], {}, _bornasco["default"], {}, _boscoChiesanuova["default"], {}, _bosnasco["default"], {}, _buggiano["default"], {}, _cabras["default"], {}, _calasetta["default"], {}, _campolongoTapogliano["default"], {}, _campomarino["default"], {}, _campomorone["default"], {}, _camporosso["default"], {}, _camporotondoEtneo["default"], {}, _caneva["default"], {}, _cannobio["default"], {}, _capoterra["default"], {}, _carlentini["default"], {}, _caronia["default"], {}, _casalzuigno["default"], {}, _cascina["default"], {}, _cassinaDePecchi["default"], {}, _castellArquato["default"], {}, _castelloDArgile["default"], {}, _cattolicaEraclea["default"], {}, _cervo["default"], {}, _cesanaTorinese["default"], {}, _chiesaInValmalenco["default"], {}, _conegliano["default"], {}, _costaVolpino["default"], {}, _costarainera["default"], {}, _crodo["default"], {}, _cuneo["default"], {}, _fabbricaCurone["default"], {}, _falcone["default"], {}, _falerna["default"], {}, _faraGeraDAdda["default"], {}, _fluminimaggiore["default"], {}, _forzaDAgro["default"], {}, _francolise["default"], {}, _furnari["default"], {}, _fusignano["default"], {}, _giaveraDelMontello["default"], {}, _gioiosaMarea["default"], {}, _govone["default"], {}, _gravellonaLomellina["default"], {}, _guspini["default"], {}, _iglesias["default"], {}, _incisaScapaccino["default"], {}, _laMaddalena["default"], {}, _lecce["default"], {}, _luino["default"], {}, _magomadas["default"], {}, _malesco["default"], {}, _manduria["default"], {}, _maracalagonis["default"], {}, _margno["default"], {}, _marmirolo["default"], {}, _marrubiu["default"], {}, _maser["default"], {}, _meina["default"], {}, _menfi["default"], {}, _mesola["default"], {}, _mezzana["default"], {}, _mioglia["default"], {}, _misiliscemi["default"], {}, _monforteSanGiorgio["default"], {}, _montecosaro["default"], {}, _mottaSantAnastasia["default"], {}, _muggia["default"], {}, _naso["default"], {}, _ne["default"], {}, _orosei["default"], {}, _palazzago["default"], {}, _palermo["default"], {}, _palmaDiMontechiaro["default"], {}, _perugia["default"], {}, _petrosino["default"], {}, _ponteNizza["default"], {}, _pontechianale["default"], {}, _portoCesareo["default"], {}, _portoscuso["default"], {}, _posada["default"], {}, _pulsano["default"], {}, _realmonte["default"], {}, _rezzoaglio["default"], {}, _roveredoInPiano["default"], {}, _rovetta["default"], {}, _salaBaganza["default"], {}, _sanCesarioDiLecce["default"], {}, _sanGiovanniSuergiu["default"], {}, _sanGodenzo["default"], {}, _sanPietroDiFeletto["default"], {}, _sanPietroInCariano["default"], {}, _sanVeroMilis["default"], {}, _sanZenoneAlLambro["default"], {}, _santAlessioSiculo["default"], {}, _santAnnaArresi["default"], {}, _santAntonioDiGallura["default"], {}, _santaTeresaDiRiva["default"], {}, _santarcangeloDiRomagna["default"], {}, _semproniano["default"], {}, _sestoCalende["default"], {}, _siculiana["default"], {}, _sorso["default"], {}, _spadafora["default"], {}, _spinetoli["default"], {}, _stintino["default"], {}, _strongoli["default"], {}, _terralba["default"], {}, _tresnuraghes["default"], {}, _vadoLigure["default"], {}, _valMasino["default"], {}, _valeggioSulMincio["default"], {}, _valledoria["default"], {}, _vallefoglia["default"], {}, _valmadrera["default"], {}, _valtournenche["default"], {}, _vignate["default"], {}, _villaputzu["default"], {}, _villasimius["default"]);

exports["default"] = _default;